import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";

function PlaceholderCard({ title, description }: { title: string; description: string }) {
  return (
    <div className="rounded-lg border border-slate-200 bg-white p-4 shadow-sm dark:border-white/10 dark:bg-slate-950/40">
      <h2 className="text-base font-semibold text-slate-900 dark:text-white">{title}</h2>
      <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">{description}</p>
      <p className="mt-3 text-xs text-slate-500">Full editor ports from Amplify dashboard next.</p>
    </div>
  );
}

export function CrmSettingsSectionPage({ tab }: { tab: string }) {
  if (tab === "modules") {
    return (
      <div className="space-y-4">
        <div>
          <h1 className="text-lg font-semibold text-slate-900 dark:text-white">Modules</h1>
          <p className="mt-1 text-sm text-slate-600 dark:text-slate-400">
            Configure standard CRM modules. Open a module to manage Setup and Fields.
          </p>
        </div>
        <Link
          to="/crm/settings/modules/lead?tab=setup"
          className="flex max-w-md items-center justify-between rounded-lg border border-slate-200 bg-white px-4 py-3 text-sm font-medium text-slate-800 shadow-sm hover:bg-slate-50 dark:border-white/10 dark:bg-slate-950/40 dark:text-slate-100 dark:hover:bg-white/5"
        >
          <span>
            Lead
            <span className="mt-0.5 block text-xs font-normal text-slate-500">Lead Entry, fields, and setup</span>
          </span>
          <ChevronRight className="size-4 shrink-0 text-slate-400" aria-hidden />
        </Link>
      </div>
    );
  }

  if (tab === "lead-forms") {
    return (
      <PlaceholderCard
        title="Lead Forms"
        description="Web-to-lead forms and embed codes for this organization."
      />
    );
  }

  if (tab === "history") {
    return (
      <PlaceholderCard
        title="CRM History"
        description="Recent CRM audit events. Use CRM Audit for the full log."
      />
    );
  }

  if (tab === "usage") {
    return (
      <PlaceholderCard title="Usage" description="Credits and usage for CRM in this organization." />
    );
  }

  if (tab === "permissions") {
    return (
      <PlaceholderCard
        title="CRM Permissions"
        description="Define what CRM roles can view, edit, and automate."
      />
    );
  }

  if (tab === "schedules" || tab === "functions") {
    return (
      <PlaceholderCard
        title={tab === "schedules" ? "Schedules" : "Functions"}
        description="Automation schedules and Deluge-style functions for CRM."
      />
    );
  }

  return (
    <PlaceholderCard
      title="CRM Users & Roles"
      description="Configure CRM-specific user roles and assignment defaults."
    />
  );
}
